class AccessCodeService {
  constructor() {
    this.quotationCodes = new Map();
    this.orderCodes = new Map();
    this.guestDisplayName = null;
  }

  setQuotationAccessCode(guid, accessCode) {
    if (guid && accessCode) {
      this.quotationCodes.set(guid, accessCode);
    }
  }

  getQuotationAccessCode(guid) {
    return this.quotationCodes.get(guid) || null;
  }

  clearQuotationAccessCode(guid) {
    this.quotationCodes.delete(guid);
  }

  setOrderAccessCode(guid, accessCode) {
    if (guid && accessCode) {
      this.orderCodes.set(guid, accessCode);
    }
  }

  getOrderAccessCode(guid) {
    return this.orderCodes.get(guid) || null;
  }

  clearOrderAccessCode(guid) {
    this.orderCodes.delete(guid);
  }

  setGuestDisplayName(name) {
    const normalizedName = String(name || "").trim();
    this.guestDisplayName = normalizedName || null;
  }

  getGuestDisplayName() {
    return this.guestDisplayName;
  }

  clearGuestDisplayName() {
    this.guestDisplayName = null;
  }
}

const accessCodeService = new AccessCodeService();

export default accessCodeService;